module.exports = __webpack_public_path__ + "img/mm.f06bd610.svg";